<form class="row row-gap-2 mb-3 page_card__wide">
    <div class="col-3 position-relative">
        <fs-vendor-select [formField]="deviceModelFilter.assetVendorId" />
    </div>
    <div class="col-3">
        <label for="modelFilter" class="form-label">Modello</label>
        <input id="modelFilter" type="text" class="form-control" [formField]="deviceModelFilter.name" />
    </div>
</form>

<div class="row page_card__wide">
    <div class="col-12 mb-3" *kaHasRoles="[permission.apparatoassetmodelWrite]; checkRealm: true">
        <button type="button" class="btn btn-light btn-sm d-flex align-items-center ms-auto" (click)="modelModal()">
            <span class="material-symbols-outlined text-primary">add</span> Crea Modello
        </button>
    </div>

    <ng-template [spinnerLoader]="deleteSubscription && !deleteSubscription.closed"></ng-template>

    <div class="col-12" [spinnerLoader]="deviceModelResource.isLoading()">
        <div class="table-responsive">
            <table class="table align-middle">
                <thead>
                    <tr>
                        <th scope="col">Marca</th>
                        <th scope="col">Modello</th>
                        <th scope="col">Tipo asset</th>
                        <th scope="col">Stato</th>
                        <th scope="col" *kaHasRoles="[permission.apparatoassetmodelWrite]; checkRealm: true"></th>
                    </tr>
                </thead>
                <tbody>
                    @for (item of deviceModelResource.value()?.content; track $index) {
                        <tr>
                            <td>{{item.assetVendor.name}}</td>
                            <td>{{item.name}}</td>
                            <td>{{item.assetType.name}}</td>
                            <td>
                                <span class="badge" [ngClass]="{'bg-success-subtle text-success': item.enabled, 'bg-danger-subtle text-danger': !item.enabled}">&#x2022; {{item.enabled ? 'ATTIVO' : 'NON ATTIVO'}}</span>
                            </td>
                            <td *kaHasRoles="[permission.apparatoassetmodelWrite]; checkRealm: true" class="text-end">
                                <button type="button" class="btn btn-sm btn-light" (click)="deleteModal(item)">
                                    <span class="material-symbols-outlined text-primary">delete</span>
                                </button>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>

    <pagination [paginationData]="paginationData" />
</div>
